// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import {
  brandSpecificTopRatedBGColor,
  brandSpecificBestSellerBGColor,
  brandSpecificTopRatedColor,
} from '@tcp/core/src/utils/utils.web';
import { TOP_RATED } from '@tcp/core/src/constants/badge.constants';

export const BadgeStyle = css`
  display: flex;
  padding: 1px 4px;
  margin-right: 8px;
  white-space: nowrap;
  border-radius: 3px;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  align-items: center;
  height: 14px;
  .top-badge-label {
    text-transform: uppercase;
    height: 14px;
    display: flex;
    align-items: center;
  }
`;

export const BadgeMobileStyles = css`
  padding: 2px 4px;
  margin-right: 2px;
  border-radius: 4px;
  height: 8px;

  .top-badge-label {
    height: 8px;
  }
`;

export const BadgeContainer = styled.div`
  ${BadgeStyle}
  background: ${(props) =>
    props.type === TOP_RATED
      ? brandSpecificTopRatedBGColor(props)
      : brandSpecificBestSellerBGColor(props)};
  .top-badge-label {
    color: ${(props) =>
      props.type === TOP_RATED ? brandSpecificTopRatedColor(props) : props.theme.colors.WHITE};
  }
  margin-bottom: 20px;
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${BadgeMobileStyles}
  }
`;
